import { Navigate, useLocation } from "react-router-dom";

const AdminToSettingsRedirect = () => {
	const location = useLocation();
	const target = `${location.pathname.replace(/^\/admin/, "/settings")}${location.search}${location.hash}`;
	return <Navigate replace to={target} />;
};

export default AdminToSettingsRedirect;
